"use client";

import { Button } from "@/components/ui/button";
import { useInfiniteScroll } from "./useInfiniteScroll";

interface InfiniteScrollTriggerProps {
  hasNextPage: boolean;
  isFetchingNextPage: boolean;
  fetchNextPage: () => void;
  label?: string;
  autoLoad?: boolean;
}

export function InfiniteScrollTrigger({
  hasNextPage,
  isFetchingNextPage,
  fetchNextPage,
  label = "Load more",
  autoLoad = true,
}: InfiniteScrollTriggerProps) {
  const sentinelRef = useInfiniteScroll({
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
    autoLoad,
  });

  return (
    <>
      <div ref={sentinelRef} className="h-4 mt-8" />
      {hasNextPage && (
        <div className="flex justify-center mt-4">
          <Button
            variant="secondary"
            onClick={fetchNextPage}
            disabled={isFetchingNextPage}
          >
            {isFetchingNextPage ? "Loading..." : label}
          </Button>
        </div>
      )}
    </>
  );
}
